import { render, staticRenderFns } from "./PreviewView.vue?vue&type=template&id=63ffd07e&"
import script from "./PreviewView.vue?vue&type=script&lang=ts&"
export * from "./PreviewView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports